export const validateEmptyInput = (rule: any, value: any, callback: any) => {
  if (value?.trim() === '') {
    callback('This field can not be empty');
  } else {
    callback();
  }
};
